<section class="card">
    <div class="card-body">
        <div class="row">
            <div class="col-12 mb-1 mb-md-3">
                <h4 class="text-black profile-table-title"><strong>Address</strong></h4>
            </div>
            <div class="col-12">
                <table class="table-edit address-table">
                    <thead class="table-head">
                        <th class="max-width-100">Address</th>
                        <th class="hidden-xs">Apartment</th>
                        <th>City</th>
                        <th class="hidden-xs">State</th>
                        <th>Postal Code</th>
                        <th>Country</th>
                        <th class="hidden-xs">Type</th>
                        <th class="profile-last-col">Actions</th>
                    </thead>
                    <tbody>
                        <tr *ngFor="let address of model.addresses" [class.isFavorite]="address.primary">
                            <td class="profile-row max-width-100">
                                <i *ngIf="address.primary" class="fa fa-star"></i>
                                <span *ngIf="address.address1">{{ address?.address1 }}</span>
                            </td>
                            <td class="hidden-xs">
                                <span *ngIf="address.address2">{{ address?.address2 }}</span>
                            </td>
                            <td>{{ address.city }}</td>
                            <td class="hidden-xs">{{ address.state }}</td>
                            <td>{{ address.postalCode }}</td>
                            <td>{{ address.country }}</td>
                            <td class="hidden-xs">{{ address.addressType.description }}</td>
                            <td class="actions">
                                <i (click)="edit(address)" class="edit-btn">
                                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 640 640">
                                        <title></title>
                                        <g id="icomoon-ignore"></g>
                                        <path fill="#cc0000" d="M611.313 28.686c-17.981-17.98-41.886-27.882-67.313-27.882-25.428 0-49.333 9.902-67.313 27.882l-408 408c-1.653 1.653-2.924 3.648-3.723 5.846l-64 176c-2.125 5.842-0.673 12.386 3.723 16.781 3.053 3.055 7.144 4.687 11.315 4.687 1.833 0 3.682-0.314 5.465-0.963l176-64c2.197-0.8 4.193-2.070 5.846-3.724l408-408c17.98-17.98 27.883-41.886 27.883-67.314s-9.902-49.333-27.883-67.313zM183.196 546.177l-140.443 51.069 51.070-140.442 354.177-354.177 89.373 89.373-354.177 354.177zM588.687 140.686l-28.687 28.687-89.373-89.373 28.687-28.687c11.936-11.936 27.806-18.509 44.686-18.509s32.75 6.574 44.687 18.51c11.936 11.936 18.51 27.806 18.51 44.686s-6.575 32.75-18.51 44.686z"></path>
                                    </svg>
                                </i>
                                <i  (click)="!address.primary? delete(address) : false" [ngClass]="{'fa-trash-o': !address.primary, 'fa-primary-contact': address.primary}" class="fa"></i>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="col-xl-12 col-md-12">
                <div class="row">
                    <div class="col-12 mt-3">
                        <div *ngIf="!isFormVisible">
                            <a class="profile-add-more"
                                    (click)="create()"
                                    id="profile-Phone-Btn">
                                Add Address
                            </a>
                        </div>
                        <form #form="ngForm" *ngIf="isFormVisible" class="row mt-3 d-flex align-items-center">
                            <div class="col-md-6 col-sm-12">
                                <div class="d-flex flex-column form-group py-0">
                                    <label class="form-control-label">Address</label>
                                    <input type="text"
                                            name="addressLine1"
                                            [(ngModel)]="editModel.address1"
                                            #addressControl="ngModel"
                                            maxlength="80"
                                            required
                                            class="form-control">
                                    <div class="form-control-error"
                                            *ngIf="!addressControl.valid && (addressControl.touched || state.isSubmitted)">
                                        <ul>
                                            <li *ngIf="addressControl?.errors?.required">Address is required.</li>
                                            <li *ngIf="addressControl?.errors?.maxlength">Must be 80 characters long.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3 col-sm-12">
                                <div class="d-flex flex-column form-group py-0 pl-xl-4">
                                    <label class="form-control-label">Apartment / Suite</label>
                                    <input type="text"
                                           name="addressLine2"
                                           [(ngModel)]="editModel.address2"
                                           #apartmentControl="ngModel"
                                           maxlength="80"
                                           class="form-control">
                                    <div class="form-control-error"
                                         *ngIf="!apartmentControl.valid && (apartmentControl.touched || state.isSubmitted)">
                                        <ul>
                                            <li *ngIf="apartmentControl?.errors?.maxlength">Must be 80 characters long.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3 col-sm-12">
                                <div class="d-flex flex-column form-group py-0 pl-xl-4">
                                    <label class="form-control-label">City</label>
                                    <input type="text"
                                           name="city"
                                           [(ngModel)]="editModel.city"
                                           #cityControl="ngModel"
                                           maxlength="60"
                                           required
                                           class="form-control">
                                    <div class="form-control-error"
                                         *ngIf="!cityControl.valid && (cityControl.touched || state.isSubmitted)">
                                        <ul>
                                            <li *ngIf="cityControl?.errors?.required">City is required.</li>
                                            <li *ngIf="cityControl?.errors?.maxlength">Must be 60 characters long.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3 col-sm-12">
                                <div class="d-flex flex-column form-group py-0">
                                    <label class="form-control-label">
                                        State/Province
                                    </label>
                                    <select name="state"
                                            [(ngModel)]="editModel.state"
                                            #stateControl="ngModel"
                                            required
                                            maxlength="50"
                                            class="form-control">
                                        <option class="form-check" *ngFor="let option of stateProvinces" [ngValue]="option.state">
                                            {{ option.description }}
                                        </option>
                                    </select>
                                    <div class="form-control-error"
                                            *ngIf="!stateControl.valid && (stateControl.touched || state.isSubmitted)">
                                        <ul>
                                            <li *ngIf="stateControl?.errors?.required">State/Province is required.</li>
                                            <li *ngIf="stateControl?.errors?.maxlength">Must be 50 characters long.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3 col-sm-12">
                                <div class="d-flex flex-column form-group py-0 pl-xl-3">
                                    <label class="form-control-label">Postal Code</label>
                                    <input type="text"
                                            name="postal-code"
                                            [(ngModel)]="editModel.postalCode"
                                            #postalCodeControl="ngModel"
                                            required
                                            maxlength="10"
                                            class="form-control">
                                    <div class="form-control-error"
                                            *ngIf="!postalCodeControl.valid && (postalCodeControl.touched || state.isSubmitted)">
                                        <ul>
                                            <li *ngIf="postalCodeControl?.errors?.required">Postal Code is required.</li>
                                            <li *ngIf="postalCodeControl?.errors?.maxlength">Must be 10 characters long.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3 col-sm-12">
                                <div class="d-flex flex-column form-group py-0 pl-xl-3">
                                    <label class="form-control-label">
                                        Country
                                    </label>
                                    <select name="country"
                                            [(ngModel)]="editModel.country"
                                            #countryControl="ngModel"
                                            required
                                            maxlength="80"
                                            class="form-control">
                                        <option class="form-check" *ngFor="let option of dictData.Country" [ngValue]="option.country">
                                            {{ option.country }}
                                        </option>
                                    </select>
                                    <div class="form-control-error"
                                            *ngIf="!countryControl.valid && (countryControl.touched || state.isSubmitted)">
                                        <ul>
                                            <li *ngIf="countryControl?.errors?.required">Country is required.</li>
                                            <li *ngIf="countryControl?.errors?.maxlength">Must be 80 characters long.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3 col-sm-12">
                                <div class="d-flex flex-column form-group py-0 pl-xl-3">
                                    <label class="form-control-label">
                                        Type
                                    </label>
                                    <select name="address-type"
                                            [(ngModel)]="editModel.addressType.constituentAddressTypeID"
                                            #addressTypeControl="ngModel"
                                            required
                                            class="form-control">
                                        <option class="form-check" *ngFor="let option of dictData.AddressType" [ngValue]="option.addressTypeId">
                                            {{ option.description }}
                                        </option>
                                    </select>
                                    <div class="form-control-error"
                                            *ngIf="!addressTypeControl.valid && (addressTypeControl.touched || state.isSubmitted)">
                                        <ul>
                                            <li *ngIf="addressTypeControl?.errors?.required">Address Type is required.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 col-sm-12">
                                <div class="d-flex align-items-center pb-1 pt-4 pt-md-0">
                                    <label class="form-control-label custom-control custom-checkbox" for="profile-Address-Primary">
                                        <input class="form-check-input custom-control-input"
                                                type="checkbox"
                                                id="profile-Address-Primary"
                                                [checked]="editModel.primary"
                                                (change)="editModel.primary = !editModel.primary">
                                        <span class="custom-control-label"></span>
                                        <span class="custom-control-description">Set As Primary</span>
                                    </label>
                                </div>
                            </div>
                            <div class="col-12">
                                <button type="button"
                                        class="btn btn-primary mr-2 mr-md-3"
                                        (click)="save()">Save</button>
                                <button type="button"
                                        class="btn btn-outline-primary"
                                        (click)="cancel()">Cancel</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
